// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

.section {
  padding: clamp(4.5rem, 10vw, 7.5rem) 0;
}

.section__inner {
  width: var(--wide);
  margin: 0 auto;
}

.section__eyebrow {
  display: block;
  margin-bottom: 0.85rem;
  font-family: var(--font-display);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--moss);
}

.section__title {
  max-width: 16ch;
  font-family: var(--font-display);
  font-size: clamp(1.85rem, 4.2vw, 2.75rem);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.015em;
  color: var(--ink);
}

.section__lead {
  max-width: 38ch;
  margin-top: 1rem;
  color: var(--muted);
  font-size: 1.08rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  min-height: 3.1rem;
  padding: 0.85rem 1.45rem;
  border: 1px solid transparent;
  border-radius: var(--radius);
  font-weight: 600;
  letter-spacing: -0.01em;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn:active {
  transform: translateY(0);
}

.btn--primary {
  background: var(--lime);
  color: var(--ink);
}

.btn--primary:hover {
  background: var(--lime-deep);
}

.btn--ghost {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
}

.btn--ghost:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.55);
}

.btn--ink {
  background: var(--ink);
  color: #fff;
}

.btn--ink:hover {
  background: var(--ink-soft);
}

.btn--outline {
  background: transparent;
  border-color: rgba(15, 46, 36, 0.22);
  color: var(--ink);
}

.btn--outline:hover {
  border-color: var(--moss);
  background: rgba(15, 46, 36, 0.04);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB;;;;uBAIqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC","sourcesContent":[".app {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\nmain {\r\n  flex: 1;\r\n}\r\n\r\n.section {\r\n  padding: clamp(4.5rem, 10vw, 7.5rem) 0;\r\n}\r\n\r\n.section__inner {\r\n  width: var(--wide);\r\n  margin: 0 auto;\r\n}\r\n\r\n.section__eyebrow {\r\n  display: block;\r\n  margin-bottom: 0.85rem;\r\n  font-family: var(--font-display);\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.14em;\r\n  text-transform: uppercase;\r\n  color: var(--moss);\r\n}\r\n\r\n.section__title {\r\n  max-width: 16ch;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(1.85rem, 4.2vw, 2.75rem);\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n  letter-spacing: -0.015em;\r\n  color: var(--ink);\r\n}\r\n\r\n.section__lead {\r\n  max-width: 38ch;\r\n  margin-top: 1rem;\r\n  color: var(--muted);\r\n  font-size: 1.08rem;\r\n}\r\n\r\n.btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.55rem;\r\n  min-height: 3.1rem;\r\n  padding: 0.85rem 1.45rem;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--radius);\r\n  font-weight: 600;\r\n  letter-spacing: -0.01em;\r\n  transition:\r\n    background-color 0.2s ease,\r\n    color 0.2s ease,\r\n    border-color 0.2s ease,\r\n    transform 0.2s ease;\r\n}\r\n\r\n.btn:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.btn--primary {\r\n  background: var(--lime);\r\n  color: var(--ink);\r\n}\r\n\r\n.btn--primary:hover {\r\n  background: var(--lime-deep);\r\n}\r\n\r\n.btn--ghost {\r\n  background: transparent;\r\n  border-color: rgba(255, 255, 255, 0.35);\r\n  color: #fff;\r\n}\r\n\r\n.btn--ghost:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  border-color: rgba(255, 255, 255, 0.55);\r\n}\r\n\r\n.btn--ink {\r\n  background: var(--ink);\r\n  color: #fff;\r\n}\r\n\r\n.btn--ink:hover {\r\n  background: var(--ink-soft);\r\n}\r\n\r\n.btn--outline {\r\n  background: transparent;\r\n  border-color: rgba(15, 46, 36, 0.22);\r\n  color: var(--ink);\r\n}\r\n\r\n.btn--outline:hover {\r\n  border-color: var(--moss);\r\n  background: rgba(15, 46, 36, 0.04);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
